export default {
  company_edit: ['company_edit'],
  company_add: ['company_add'],
  company_management: ['company_management'],

  company_group_management: ['company_group_management'],
  company_group_edit: ['company_group_edit'],
  company_group_add: ['company_group_add'],
  company_group_delete: ['company_group_delete'],
  company_group_archive: ['company_group_archive'],

  company_user_management: ['company_user_management'],
  company_user_edit: ['company_user_edit'],
  company_group_update_permissions: ['company_group_update_permissions'],
  company_user_add: ['company_user_add'],
  company_user_delete: ['company_user_delete'],
  company_user_archive: ['company_user_archive'],

  api_key_management: ['api_key_management'],
  api_key_add: ['api_key_add'],
  api_key_edit: ['api_key_edit'],
  api_key_delete: ['api_key_delete'],
  api_key_archive: ['api_key_archive'],

  connect_add: ['connect_add'],
  connect_delete: ['connect_delete']
}
